<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row">
      <div class="col-md-12">
        <div class="top-list-toolbar">
          <div>
            <h4 class="text-primary" @click="backParent">Purchase Order</h4>
            <ol class="breadcrumb breadcrumb-card-header">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);" @click="backParent">Purchase Order</a>
              </li>
              <li class="breadcrumb-item active">
                <span v-if="order.id === null">New</span>
                <span v-else>
                  {{ order.purchasing_no }}
                </span>
              </li>
            </ol>
            <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="action" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="order.id !== null">Action</button>
            <div class="dropdown-menu" aria-labelledby="action">
              <a href="javascript:void(0)" class="dropdown-item" @click="backParent">Back</a>
              <a href="javascript:void(0)" class="dropdown-item" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false">Request Edit</a>
              <a href="javascript:void(0)" class="dropdown-item" data-toggle="modal" data-target="#modalRequestVoid" data-backdrop="static" data-keyboard="false">Request Delete</a>
              <a href="javascript:void(0)" class="dropdown-item" @click="syncOrderAll">Sync Order</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="printPO">Print</a>
              <a href="javascript:void(0)" class="dropdown-item" @click="resetOrderDone">Reset Qty Order</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="removeOrder" v-show="authUser.permissions.purchasing_order_delete">Delete</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="unlock" v-show="authUser.permissions.purchasing_order_unlock">Unlock</a>
            </div>
            <button type="button" @click="updateOrder" class="btn btn-sm btn-soft-primary pull-left" v-show="order.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
            <button type="button" @click="createOrder" class="btn btn-sm btn-soft-primary pull-left" v-show="order.id == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
            <button type="button" @click="approve" class="btn btn-sm btn-soft-outline-primary pull-left" v-if="order.purchasing_no !== null">Approve</button>
            <!-- <button type="button" class="btn btn-sm btn-warning pull-right" v-show="order.purchasing_no !== null" ><i class="fa fa-reply" aria-hidden="true"></i> Request Edit</button> -->
            <button type="button" class="btn btn-sm btn-soft-outline-primary pull-left" @click="validateDetailDuplicate">Validate</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- card1 -->
      <div class="col-md-12">
        <div class="card card-list">
          <div class="card-header">
            <div class="col-md-12">
              <h5 class="text-primary">
                <span v-if="order.id === null">New</span>
                <span v-else>{{ order.purchasing_no }}</span>
                <span class="badge badge-primary ml-1">{{ order.status }}</span>
              </h5>
            </div>
          </div>
          <div class="card-body">
            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                <ul v-for="(a, index) in alert" :key="index">
                  <li v-html="a.message"></li>
                </ul>
              </div>
            <div class="row">
              <div class="col-md-4">
                <dl class="row dl-custom font-12">
                  <dt class="col-md-4">Order No.</dt>
                  <dd class="col-md-8">
                    <span v-if="order.lock">{{ order.sp_no }}</span>
                    <input type="text" class="form-control form-control-lite" v-model="order.sp_no" v-else @blur="getSpNo"/>
                    <span style="color: red" v-if="error.sp_no !== ''">{{ error.sp_no }}</span>
                  </dd>
                  <dt class="col-md-4">Type</dt>
                  <dd class="col-md-8">
                    <select class="form-control" v-model="order.type_id" :disabled="order.lock">
                      <option v-for="t in purchasingTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                    </select>
                  </dd>
                  <dt class="col-md-4">Tanggal</dt>
                  <dd class="col-md-8">
                    <datetime v-if="authUser.permissions.sale_backdate" v-model="order.purchasing_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" :disabled="order.lock"></datetime>
                    <datetime v-else v-model="order.purchasing_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" @input="checkDate" :disabled="order.lock"></datetime>
                  </dd>

                  <dt class="col-md-4" v-if="order.type_id == 2">Jatuh Tempo</dt>
                  <dd class="col-md-8" v-if="order.type_id == 2">
                    <select v-model="order.term_due_id" class="form-control form-control-lite" :disabled="order.lock">
                      <option v-for="t in termDueList" :key="t.id" :value="t.id">{{ t.name }}</option>
                      <option value=""><i>Custom</i></option>
                    </select>
                  </dd>

                  <dt class="col-md-4" v-if="order.type_id == 2 && order.term_due_id == ''">Tanggal Jatuh Tempo</dt>
                  <dd class="col-md-8" v-if="order.type_id == 2 && order.term_due_id == ''">
                    <span v-if="order.lock === true"><b>{{ order.purchasing_due_date | dateFormat('DD/MM/YYYY') }}</b></span>
                    <datetime v-else v-model="order.purchasing_due_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                  </dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl class="row dl-custom font-12">
                  <dt class="col-md-4">Vendor</dt>
                  <dd class="col-md-8">
                    <v-select class="vsc-custom" :options="vendorSelect" :reduce="vendor => vendor.meta.code" label="vendor" v-model="order.vendor_no" :disabled="order.lock"/>
                  </dd>

                  <dt class="col-md-4">Company</dt>
                  <dd class="col-md-8">
                    <select v-model="order.company_no" class="form-control form-control-lite" :disabled="order.lock || order.purchasing_no !== null" @change="setCompany">
                      <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                    </select>
                  </dd>

                  <dt class="col-md-4">Tax</dt>
                  <dd class="col-md-8">
                    <select v-model="order.tax_id" class="form-control form-control-lite" @change="setTax" :disabled="order.lock">
                      <option v-for="t in taxList" :key="t.id" :value="t.id">{{ t.name }}</option>
                    </select>
                  </dd>
                </dl>
              </div>
              <div class="col-md-4">
                <h5>Pembelian:</h5>
                <ul v-for="(p, index) in order.purchasings" :key="index">
                  <li>
                    <span style="cursor: pointer; color: blue;" @click="getPurchasingByNo(p.purchasing_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false" >
                      {{ p.purchasing_no }}
                    </span>
                    - {{ p.purchasing_date | dateFormat('DD/MM/YYYY') }}
                    <!-- <span class="ml-2 font-16" style="color: red; cursor: pointer" @click="removeOrder(index)" v-if="purchasing.lock !== true"><i class="fa fa-trash-o" aria-hidden="true"></i></span> -->
                  </li>
                </ul>
                <hr>
                <dl class="row dl-custom font-12">
                  <dt class="col-md-4">Notes</dt>
                  <dd class="col-md-8">
                    <textarea class="form-control form-control-lite" v-model="order.notes" rows="5" :disabled="order.lock"></textarea>
                  </dd>
                </dl>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ul class="nav nav-tabs nav-bordered">
                  <li class="nav-item"><a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link active">Order</a></li>
                  <li class="nav-item"><a href="#print" data-toggle="tab" aria-expanded="false" class="nav-link">Print</a></li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane active" id="general">
                    <div class="table-responsive">
                      <table class="table table-sm table-item table-hover table-striped">
                        <thead>
                          <th class="text-center" style="width: 1%">No.</th>
                          <th>Product</th>
                          <th>Qty</th>
                          <th>Done</th>
                          <th>UoM</th>
                          <th class="text-right">Price</th>
                          <th class="text-right">Discount</th>
                          <th class="text-right">(%)</th>
                          <th class="text-right">DPP</th>
                          <th class="text-right">Tax</th>
                          <th class="text-right">Total</th>
                          <th>#</th>
                        </thead>
                        <tbody>
                          <tr v-for="(d, index) in order.details" :key="index">
                            <td class="text-center">{{ d.queue }}</td>
                            <td><v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="d.product_no" @input="setProduct(index)" :disabled="order.lock"/></td>
                            <td><input type="text" class="form-control" v-model="d.qty" v-on:keyup="calcRowTotal(index)" :disabled="order.lock"/></td>
                            <td><input type="text" class="form-control" v-model="d.qty_done" :disabled="order.lock"/></td>
                            <td>
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="d.uom_id === null"></span>
                              <span v-else>
                                <select class="form-control" v-model="d.uom_id" :disabled="order.lock">
                                  <option v-for="(u,idx) in d.uomList" :key="idx" :value="u.id">{{ u.name }}</option>
                                </select>
                              </span>
                            </td>
                            <td><input class="form-control form-control-right" type="text" id="price" v-model="d.price" v-money="money"  v-on:keyup="calcRowTotal(index)" :disabled="order.lock"/></td>
                            <td>{{ d.discount }}</td>
                            <td><input class="form-control form-control-right" type="text" id="price" v-model="d.discount_percentage" v-on:keyup="calcRowTotal(index)" :disabled="order.lock"/></td>
                            <td class="text-right">{{ d.subtotal | currency }}</td>
                            <td class="text-right">{{ d.tax | currency }}</td>
                            <td class="text-right">{{ d.total | currency }}</td>
                            <td>
                              <!-- <button type="button" class="btn btn-danger btn-sm" @click="editDetail(d.id)"  data-toggle="modal" data-target="#modalPurchasingDetail" data-backdrop="static" data-keyboard="false" >Edit</button> -->
                              <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeDetail(index)" :disabled="order.lock"><i class="fa fa-trash" aria-hidden="true"></i></button>
                              <!-- <button type="button" class="btn btn-sm btn-hard-primary" @click="syncOrder(index)" v-show="order.lock === false"><i class="fa fa-refresh" aria-hidden="true"></i></button> -->
                              <!-- <button type="button" class="btn btn-sm btn-hard-primary" @click="selectProductToInventory(d.product_no)">
                                <i class="fa fa-share" aria-hidden="true"></i>
                              </button> -->
                            </td>
                          </tr>
                          <tr>
                            <td colspan="12"><span @click="addNewLine" class="link-secondary" v-if="order.lock === false">Add Product</span></td>
                          </tr>
                          <tr>
                            <td colspan="10" class="text-right font-14"><b>Subtotal</b></td>
                            <td class="text-right">
                              <span>{{ order.subtotal | currency }}</span>
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="10" class="text-right font-14"><b>Discount</b></td>
                            <td class="text-right">
                              <!-- <input type="text" v-model="order.discount" class="form-control form-control-right" v-if="order.lock === false"/> -->
                              <span>({{ order.discount | currency }})</span>
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="10" class="text-right font-14"><b>Tax</b></td>
                            <td class="text-right">{{ order.tax | currency }}</td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="10" class="text-right font-14"><b>Total</b></td>
                            <td class="text-right"><b>{{ order.total| currency }}</b></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="tab-pane" id="print">
                    <div class="table-responsive">
                      <table class="table table-sm table-item table-hover table-striped">
                        <thead>
                          <th class="text-center">No</th>
                          <th>Product</th>
                          <th>Qty</th>
                          <th>Done</th>
                          <th>UoM</th>
                          <th class="text-right">Price</th>
                          <th class="text-right">Discount</th>
                          <th class="text-right">(%)</th>
                          <th class="text-right">DPP</th>
                          <th class="text-right">Tax</th>
                          <th class="text-right">Total</th>
                          <th class="text-right">Notes</th>
                          <th></th>
                        </thead>
                        <tbody>
                          <tr v-for="(d, index) in getDataDetails" :key="index">
                            <td class="text-center">{{ d.queue }}.</td>
                            <td>
                              <span><b>[{{ d.product_no }}]</b> {{ d.product }}</span>
                            </td>
                            <td>{{ d.qty }}</td>
                            <td>{{ d.qty_done }}</td>
                            <td>{{ d.uom_id }}</td>
                            <td>{{ d.price | currency }}</td>
                            <td>{{ d.discount | currency }}</td>
                            <td class="text-right">{{ d.discount_percentage | currency }}</td>
                            <td class="text-right">{{ d.subtotal | currency }}</td>
                            <td class="text-right">{{ d.tax | currency }}</td>
                            <td class="text-right">{{ d.total | currency }}</td>
                            <td><textarea class="form-control" v-model="d.notes"></textarea></td>
                            <td>
                              <i class="fa fa-arrow-circle-up font-18 text-ref-sales" aria-hidden="true" @click="moveUp(index)"></i>
                              <i class="fa fa-arrow-circle-down font-18 text-ref-sales ml-2" aria-hidden="true" @click="moveDown(index)"></i>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="10" class="text-right font-14"><b>Subtotal</b></td>
                            <td class="text-right">
                              <span>{{ order.subtotal | currency }}</span>
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="10" class="text-right font-14"><b>Discount</b></td>
                            <td class="text-right">
                              <!-- <input type="text" v-model="order.discount" class="form-control form-control-right" v-if="order.lock === false"/> -->
                              <span>({{ order.discount | currency }})</span>
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="10" class="text-right font-14"><b>Tax</b></td>
                            <td class="text-right">{{ order.tax | currency }}</td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="10" class="text-right font-14"><b>Total</b></td>
                            <td class="text-right"><b>{{ order.total| currency }}</b></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                      <button class="btn btn-sm btn-success pull-right" @click="saveNotes">Save Notes</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-6">
        <h5>Logs:</h5>
        <div class="alert alert-info" role="alert" v-for="l in order.logs" :key="l.id">
          <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
        </div>
      </div>
    </div>
    <PurchasingModal />
    <PurchasingRequestModal @getRequestEdit='requestEdit' @getRequestVoid="requestVoid"/>
  </div>
</template>

<script>
import Axios from 'axios'
import { getHeader, lockUrl, productUrl, purchasingOrderUrl, purchasingUrl, purchasing2Url } from '../../config'
import { mapState } from 'vuex'
import PurchasingModal from '@/components/purchasing/PurchasingModal.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import PurchasingRequestModal from '@/components/purchasing/PurchasingRequestModal.vue'

export default {
  name: 'PurchasingOrderForm',
  props: ['order'],
  components: {
    PurchasingModal,
    Loading,
    PurchasingRequestModal
  },
  data () {
    return {
      alert: [],
      error: {
        sp_no: ''
      },
      dataOrder: {
        purchasing_no: null
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: false,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      vendorList: state => state.vendors.vendorList,
      companyList: state => state.companies.companyList,
      uomList: state => state.uom.uomList,
      productListSelect: state => state.products.productTotalList,
      taxList: state => state.taxes.taxList,
      termDueList: state => state.termduedates.termDueList,
      purchasingTypeList: state => state.purchasingTypes.purchasingTypeList
    }),
    getDataDetails () {
      var col = 'queue'
      var ascending = true
      return this.order.details.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    totalDetailSubtotal () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, '') * parseInt(array[i].qty))
      }
      return sum
    },
    totalDetail () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalDetailTax () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].tax)
      }
      return sum
    },
    totalDetailDiscount () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].discount)
      }
      return sum
    },
    vendorSelect () {
      var loop = []
      var array = this.vendorList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          vendor: array[i].vendor_no + ' - ' + array[i].name,
          meta: {
            code: array[i].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    productselect: function () {
      var loop = []
      var array = this.productListSelect
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  mounted () {
    var date = new Date()
    this.goDispatch(date)
  },
  methods: {
    moveUp (index) {
      var current = index
      var before = index - 1
      var currentData = {}
      var beforeData = {}
      if (current <= 0) {
        console.log('current index 0')
      } else {
        currentData = this.getDataDetails[current]
        beforeData = this.getDataDetails[before]
        console.log('current: ' + current)
        console.log('currentData.queue: ' + currentData.queue)
        console.log(currentData)
        if (currentData.queue === 1) {
        } else {
          currentData.queue = currentData.queue - 1
          beforeData.queue = beforeData.queue + 1
          console.log('currentData')
          console.log(currentData)
        }
      }
    },
    moveDown (index) {
      var current = index
      var next = index + 1
      var currentData = {}
      var nextData = {}
      if (current < 0) {
      } else {
        currentData = this.getDataDetails[current]
        nextData = this.getDataDetails[next]
        if (currentData.queue === this.getDataDetails.length) {
        } else {
          currentData.queue = currentData.queue + 1
          nextData.queue = nextData.queue - 1
        }
      }
    },
    async saveNotes () {
      var obj = {
        details: this.order.details
      }
      console.log(obj)
      await Axios.post(purchasingOrderUrl + '/detail-notes', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backClickID', this.order.id)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async requestVoid (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.order.purchasing_no,
        lock_note: value,
        type: 'purchasing-order-void'
      }
      console.log(obj)
      await Axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', 'Purchasing Delete has been requested', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    async unlock () {
      var body = {
        id: this.order.id
      }
      await this.$swal.fire({
        title: 'Are you sure unlock this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#28A745',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Unlock it!'
      }).then((result) => {
        if (result.value) {
          Axios.post(purchasingOrderUrl + '/unlock', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
              this.$swal('Success', response.data.message, 'success')
              this.$emit('backSaveChild')
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.order.purchasing_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = (Math.round(remaining / (1000 * 3600 * 24)))
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 0) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.order.purchasing_date = date1.toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.order.purchasing_date = date1.toISOString()
      }
    },
    async removeOrder () {
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          Axios.delete(purchasingOrderUrl + '/' + this.order.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
              this.$swal('Success', response.data.message, 'success')
              this.backParent()
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async requestEdit (value) {
      var purchasing = this.order.purchasings.filter(d => d.id !== null)
      var note = ''
      if (purchasing.length > 0) {
        // this.$swal('Validation', '<b>Order</b> sudah diproses pembelian, cek <b>Pembelian</b> terlebih dahulu', 'error')
        // return false
        note = '[already purchase]'
      }
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.order.purchasing_no,
        lock_note: value + ' ' + note,
        type: 'purchasing-order'
      }
      await Axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', 'Purchasing Order has been requested', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async resetOrderDone () {
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        array[i].qty_done = 0
      }
    },
    async syncOrderAll () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        await this.syncOrder(i, 'no reply')
      }
      await this.$emit('backClickID', this.order.id)
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success sync order to purchase', 'success')
    },
    async syncOrder (index, reply) {
      this.$Progress.start()
      this.loader.isLoading = true
      var detail = this.order.details[index]
      var obj = {
        product_no: detail.product_no,
        order_no: detail.purchasing_no,
        price: detail.price.replace(/\./g, ''),
        uom_id: detail.uom_id
      }
      console.log(obj)
      console.log(purchasingOrderUrl + '/sync-to-purchasing')
      await Axios.post(purchasingOrderUrl + '/sync-to-purchasing', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
          if (reply === 'reply') {
            this.$swal('Success', response.data.message, 'success')
          }
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    getPurchasingByNo (purchasing) {
      this.$store.dispatch('getPurchasingShowByNo', { purchasing_no: purchasing })
    },
    setCompany () {
      var cmp = this.companyList.find(d => d.company_no === this.order.company_no)
      this.order.tax_id = cmp.tax_id
      this.setTax()
    },
    getSpNo () {
      var data = {
        sp_no: this.order.sp_no
      }
      Axios.post(purchasingOrderUrl + '/get-sp-no', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.error.sp_no = ''
        })
        .catch(error => {
          console.log(error.response)
          this.error.sp_no = error.response.data.message
        })
    },
    setTax: function () {
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        this.calcRowTotal(i)
      }
    },
    getMax (array, propName) {
      var max = 0
      var maxItem = null
      for (var i = 0; i < array.length; i++) {
        var item = array[i]
        if (item[propName] > max) {
          max = item[propName]
          maxItem = item
        }
      }
      return maxItem
    },
    async addNewLine () {
      var arr = this.order.details
      var detailMax = this.getMax(arr, 'queue')
      var max = detailMax.queue + 1
      var obj = {
        purchasing_no: null,
        purchasing_date: null,
        branch_no: null,
        product_no: null,
        product: null,
        description: null,
        qty: 1,
        qty_done: 0,
        uom_id: null,
        price: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        discount_percentage: '0',
        subtotal: '0',
        total: '0',
        company_no: null,
        vendor_no: null,
        notes: null,
        queue: max
      }
      this.order.details.push(obj)
    },
    async removeDetail (index) {
      var detail = this.order.details[index]
      if (typeof detail.id === 'undefined') {
        this.order.details.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(purchasingUrl + '/order/detail/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.order.details.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
      this.order.discount = this.totalDetailDiscount
      this.order.tax = this.totalDetailTax
      this.order.total = this.totalDetail
    },
    calcRowTotal: function (index) {
      var qty = this.order.details[index].qty
      var amount = parseFloat(this.order.details[index].price.toString().replace(/\./g, ''))
      var discountPercentage = parseFloat(this.order.details[index].discount_percentage === '' ? '0' : this.order.details[index].discount_percentage)
      var discount = amount * discountPercentage / 100
      var subtotal = amount - discount
      var tax = this.taxList.find(d => d.id === this.order.tax_id)
      var dpp = 0
      var taxAmount = 0
      if (tax.include === false) {
        taxAmount = subtotal * tax.amount / 100
        dpp = subtotal
      } else {
        if (tax.amount === '0') {
          taxAmount = 0
          dpp = subtotal
        } else {
          if (tax.amount === '11') {
            dpp = subtotal / 1.11
            taxAmount = subtotal - dpp
          } else {
            dpp = subtotal / 1.1
            taxAmount = subtotal - dpp
          }
        }
      }
      this.order.details[index].discount = discount.toString()
      this.order.details[index].subtotal = Math.round(dpp)
      this.order.details[index].tax = Math.round(taxAmount)
      this.order.details[index].total = (Math.round(dpp) + Math.round(taxAmount)) * qty

      this.order.discount = this.totalDetailDiscount
      this.order.subtotal = this.totalDetailSubtotal
      this.order.tax = this.totalDetailTax
      this.order.total = this.totalDetail
    },
    async setProduct (index) {
      var product = this.productListSelect.find(d => d.product_no === this.order.details[index].product_no)
      this.order.details[index].price = product.cost === null ? '0' : product.cost
      this.order.details[index].uom_id = null
      var body = {
        product_no: product.product_no
      }
      console.log(productUrl + '/uom/list')
      console.log(body)
      await Axios.post(productUrl + '/uom/list', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.order.details[index].uomList = response.data.data
          this.order.details[index].uom_id = product.uom_id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async approve () {
      await this.updateOrder()
      await Axios.post(purchasingUrl + '/order/approve', this.dataOrder, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
      this.alert = []
      await this.$emit('backSaveChild')
    },
    async goDispatch (date) {
      var payload = {
        date: date
      }
      await this.$store.dispatch('getProductWithTotal', payload)
    },
    printPO: function () {
      window.open(purchasing2Url + '/print/po/' + this.order.id, '_blank')
    },
    async updateOrder () {
      await this.validateDetailDuplicate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Error', 'Data Order Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      this.dataOrder = {}
      var detail = []
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        var obj = {}
        if (array[i].product_no !== null) {
          if (typeof array[i].id === 'undefined') {
            obj = {
              purchasing_no: array[i].purchasing_no,
              purchasing_date: array[i].purchasing_date,
              branch_no: array[i].branch_no,
              product_no: array[i].product_no,
              product_sku: null,
              description: array[i].description,
              qty: array[i].qty,
              qty_done: array[i].qty_done,
              uom_id: array[i].uom_id,
              price: array[i].price.replace(/\./g, ''),
              tax_id: array[i].tax_id,
              tax: array[i].tax,
              discount: array[i].discount,
              subtotal: array[i].subtotal,
              total: array[i].total,
              company_no: array[i].company_no,
              vendor_no: array[i].vendor_no,
              discount_percentage: array[i].discount_percentage,
              notes: array[i].notes,
              queue: array[i].queue
            }
            detail.push(obj)
          } else {
            obj = {
              id: array[i].id,
              purchasing_no: array[i].purchasing_no,
              purchasing_date: array[i].purchasing_date,
              branch_no: array[i].branch_no,
              product_no: array[i].product_no,
              product_sku: null,
              description: array[i].description,
              qty: array[i].qty,
              qty_done: array[i].qty_done,
              uom_id: array[i].uom_id,
              price: array[i].price.replace(/\./g, ''),
              tax_id: array[i].tax_id,
              tax: array[i].tax,
              discount: array[i].discount,
              subtotal: array[i].subtotal,
              total: array[i].total,
              company_no: array[i].company_no,
              vendor_no: array[i].vendor_no,
              discount_percentage: array[i].discount_percentage,
              notes: array[i].notes,
              queue: array[i].queue
            }
            detail.push(obj)
          }
        }
      }
      this.dataOrder.id = this.order.id
      this.dataOrder.purchasing_no = this.order.purchasing_no
      this.dataOrder.purchasing_date = this.order.purchasing_date
      this.dataOrder.purchasing_due_date = this.order.purchasing_due_date
      this.dataOrder.ref_no = this.order.ref_no
      this.dataOrder.branch_no = this.order.branch_no
      this.dataOrder.vendor_no = this.order.vendor_no
      this.dataOrder.subtotal = this.order.subtotal
      this.dataOrder.tax_id = this.order.tax_id
      this.dataOrder.tax = this.order.tax
      this.dataOrder.discount = this.order.discount
      this.dataOrder.total = this.order.total
      this.dataOrder.delivery_cost = this.order.delivery_cost
      this.dataOrder.deliver_no = this.order.deliver_no
      this.dataOrder.status = 'approve'
      this.dataOrder.type_id = this.order.type_id
      this.dataOrder.lock = true
      this.dataOrder.company_no = this.order.company_no
      this.dataOrder.term_due_id = this.order.term_due_id
      this.dataOrder.ext_no = this.order.ext_no
      this.dataOrder.sp_no = this.order.sp_no
      this.dataOrder.notes = this.order.notes
      this.dataOrder.details = detail
      console.log(this.dataOrder)
      await Axios.put(purchasingUrl + '/order/' + this.order.id, this.dataOrder, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$swal('Order', 'Update order purchase?', 'success')
      await this.$emit('backClickID', this.order.id)

      var arrayDetail = this.order.details
      for (let i = 0; i < arrayDetail.length; i++) {
        await this.syncOrder(i, 'no reply')
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$emit('backSaveChild')
    },
    async createOrder () {
      await this.validateDetailDuplicate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Error', 'Data Order Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      var detail = []
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_no !== null) {
          var obj = {
            purchasing_no: array[i].purchasing_no,
            purchasing_date: array[i].purchasing_date,
            branch_no: array[i].branch_no,
            product_no: array[i].product_no,
            product_sku: array[i].product_sku,
            description: array[i].description,
            qty: array[i].qty,
            qty_done: array[i].qty_done,
            uom_id: array[i].uom_id,
            price: array[i].price.replace(/\./g, ''),
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            discount: array[i].discount,
            subtotal: array[i].subtotal,
            total: array[i].total,
            company_no: array[i].company_no,
            vendor_no: array[i].vendor_no,
            discount_percentage: array[i].discount_percentage,
            notes: array[i].notes,
            queue: array[i].queue
          }
          detail.push(obj)
        }
      }
      this.dataOrder.purchasing_date = this.order.purchasing_date
      this.dataOrder.purchasing_due_date = this.order.purchasing_due_date
      this.dataOrder.ref_no = this.order.ref_no
      this.dataOrder.branch_no = this.order.branch_no
      this.dataOrder.vendor_no = this.order.vendor_no
      this.dataOrder.subtotal = this.order.subtotal
      this.dataOrder.tax_id = this.order.tax_id
      this.dataOrder.tax = this.order.tax
      this.dataOrder.discount = this.order.discount
      this.dataOrder.total = this.order.total
      this.dataOrder.delivery_cost = this.order.delivery_cost
      this.dataOrder.deliver_no = this.order.deliver_no
      this.dataOrder.status = 'approve'
      this.dataOrder.type_id = this.order.type_id
      this.dataOrder.lock = true
      this.dataOrder.company_no = this.order.company_no
      this.dataOrder.term_due_id = this.order.term_due_id
      this.dataOrder.ext_no = this.order.ext_no
      this.dataOrder.sp_no = this.order.sp_no
      this.dataOrder.notes = this.order.notes
      this.dataOrder.details = detail

      await Axios.post(purchasingUrl + '/order', this.dataOrder, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backSaveChild')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      this.alert = []
    },
    async validateDetailDuplicate () {
      this.alert = []
      var array = this.order.details
      var result = []
      var resultProductNo = []
      var resultProductUom = []
      array.reduce(function (res, value) {
        // Check product_no null & duplicate
        if (value.product_no !== null) {
          var price = value.price.replace(/\./g, '')
          var key = value.product_no + price
          console.log(key)
          if (!res[key]) {
            res[key] = {
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            }
          } else {
            result.push({
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            })
          }
          // check uom null
          if (value.uom_id === null) {
            resultProductUom.push({
              id: value.id + 'uom',
              product_no: value.product_no
            })
          }
          if (value.product_no === null) {
            resultProductNo.push({
              id: res
            })
          }
        } else {
          resultProductNo.push({
            id: res
          })
        }
        return res
      }, {})

      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          this.alert.push({
            message: 'Duplicate Product & Price (<b>' + result[i].product_no + ' | ' + result[i].price + '</b>)'
          })
        }
      }
      if (resultProductUom.length > 0) {
        for (let z = 0; z < resultProductUom.length; z++) {
          this.alert.push({
            message: '<b>Uom</b> cannot be null ' + resultProductUom[z].product_no
          })
        }
      }
      if (this.order.sp_no === null) {
        this.alert.push({
          message: '<b>Order No</b> harus diinput terlebih dahulu'
        })
      }
      if (this.order.vendor_no === null) {
        this.alert.push({
          message: '<b>Vendor</b> harus diinput terlebih dahulu'
        })
      }
      if (this.order.type_id === null) {
        this.alert.push({
          message: '<b>Type Order</b> harus diinput terlebih dahulu'
        })
      }
      if (this.order.tax_id === null) {
        this.alert.push({
          message: '<b>Tax</b> harus diinput terlebih dahulu'
        })
      }
    },
    backParent () {
      this.alert = []
      this.$emit('backClicked')
    }
  }
}
</script>

<style>
.text-ref-sales {
  color: #28A745;
  cursor: pointer;
}
</style>
